import React from "react";
import { resolveImg } from "@/lib/api";
import { Skeleton } from "@/components/ui/skeleton";

export const CategoryTiles = ({ categories, loaded = true, onSelect }) => (
  <section className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 pt-6">
    {/* Always a single row: horizontally scrollable so any number of categories
        stays reachable without ever wrapping onto a second line, on any screen size. */}
    <div className="flex gap-3 sm:gap-4 overflow-x-auto scrollbar-none scroll-bouncy -mx-1 px-1">
      {!loaded ? (
        // Same footprint as the real tiles — prevents the page from jumping/flickering
        // once categories arrive a beat later.
        [...Array(6)].map((_, i) => (
          <div key={i} className="flex flex-col items-center w-[104px] sm:w-[128px] shrink-0">
            <Skeleton className="w-full aspect-[4/5] rounded-2xl" />
            <Skeleton className="mt-2 h-3 w-3/4" />
          </div>
        ))
      ) : (
        categories.map((cat) => (
          <button
            key={cat.slug}
            data-testid="home-category-tile"
            onClick={() => onSelect(cat)}
            className="group flex flex-col items-center w-[104px] sm:w-[128px] shrink-0 focus-visible:outline-none"
          >
            <div className="w-full aspect-[4/5] rounded-2xl overflow-hidden bg-[hsl(var(--sand))] card-shadow-soft">
              <img src={resolveImg(cat.image)} alt={cat.name} loading="lazy" decoding="async" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
            </div>
            <span className="mt-2 w-full px-0.5 text-[11px] sm:text-sm text-foreground/85 text-center leading-tight break-words line-clamp-2">{cat.name}</span>
          </button>
        ))
      )}
    </div>
  </section>
);
